import { Primary } from '@decorators/entity-primary.decorator';
import { Required } from '@decorators/entity-required.decorator';
import { KeepProperty } from '@decorators/entity-keepproperty.decorator';

import { v4 as uuidv4 } from 'uuid';

import { Entity } from './entity.class';
import { Phrase } from './phrase.class';

export enum QuestionType {
	CHOICE = 'choice',
	YES_NO = 'yes_no',
	TEXT = 'text',
	NUMBER = 'number',
	LOGEMENT = 'logement',
	PIECE_SINISTRE = 'piece_sinistre',
	QUESTION = 'question',
	QUESTION_PRECO = 'question_preco',
	QUESTION_RED = 'question_red',
	QUESTION_BLUE = 'question_blue',
	COMBINED = 'combined',
	PHRASE_COMBINED = 'phrase_combined',
	ELEMENT_NAME = 'element_name',
	TIME_INTERVENTION = 'time_intervention',
	PERSONNES_PRESENTES = 'personnes_presentes',
}

// export class PreconisationType {
// 	label: string;
// 	option: string;
// }


export class Question implements Entity {
	@Required
	@Primary
	id: number;

	@Required
	uuid: string;

	prefix: string;
	prefixPreco: string;
	suffix: string;

	@Required
	type: QuestionType;

	@Required
	hasPhoto: boolean = true;

	@Required
	noPhoto: boolean = false;
	photoBeforeSuffix: boolean = false;

	@KeepProperty
	options?: string[];

	canAddOption?: boolean;
	lineBreak?: boolean;
	duplicateDependency?: boolean;
	noColorOption?: boolean;
	unMixed?: boolean;
	isReco?: boolean;
	multiSelect?: boolean;
	@KeepProperty
	conditions?: string[];
	conditionQuestion?: string;
	phrase?: Phrase;
	phrasepreco?: Phrase;
	phraseremarque?: Phrase;
	@KeepProperty
	phrasecombined?: number[];
	sort: number = 0;
	isVisibleInReport: boolean = true;
	forcePiece: boolean = false;

	constructor() {	
		if (!this.uuid)
			this.uuid = uuidv4();
	}
}
